export const indicationLink = {
  title: 'Link de indicação',
  description:
    'indique e ganhe matchcoins por trazer os seus amigos para jogar com você'
};
